import { Map } from "immutable";

export type DayName = "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday" | "Sunday";

const successiveDays: Map<string, string> = Map([
    ["Monday", "Tuesday"],
    ["Tuesday", "Wednesday"],
    ["Wednesday", "Thursday"],
    ["Thursday", "Friday"],
    ["Friday", "Saturday"],
    ["Saturday", "Sunday"],
    ["Sunday", "Monday"]
]);

const exported = {
    areDaysSuccessive(firstDay: DayName, secondDay: DayName) {
        return successiveDays.get(firstDay) === secondDay || successiveDays.get(secondDay) === firstDay;
    },

    getI18NKeyForDay(day: DayName) {
        switch (day) {
            case "Monday":
                return "EX_MON";
            case "Tuesday":
                return "EX_TUE";
            case "Wednesday":
                return "EX_WED";
            case "Thursday":
                return "EX_THU";
            case "Friday":
                return "EX_FRI";
            case "Saturday":
                return "EX_SAT";
            case "Sunday":
                return "EX_SUN";
            default:
                return "";
        }
    }
};

export default exported;

export const { areDaysSuccessive, getI18NKeyForDay } = exported;
